export default class ElevatorState {
  id = null;
  facility = null;
  savedOn = "";
  savedById = null;
  savedByUsername = "";
  summary = "";
  ruleStates = [];

  /*
    Elevator specific state fields
   */
  // in the car
  carRideComfort = false;
  carRideComfortNote = "";
  carRideComfortDocs = [];

  carDoorRunProps = false;
  carDoorRunPropsNote = "";
  carDoorRunPropsDocs = [];

  carSafetyGridLightBarrier = false;
  carSafetyGridLightBarrierNote = "";
  carSafetyGridLightBarrierDocs = [];

  carReversingDevice = false;
  carReversingDeviceNote = "";
  carReversingDeviceDocs = [];

  carOpenDoorButton = false;
  carOpenDoorButtonNote = "";
  carOpenDoorButtonDocs = [];

  carSign = false;
  carSignNote = "";
  carSignDocs = [];

  carEmergencyCall = false;
  carEmergencyCallNote = "";
  carEmergencyCallDocs = [];

  carCabinFloor = false;
  carCabinFloorNote = "";
  carCabinFloorDocs = [];

  carBaseboardWallCeiling = false;
  carBaseboardWallCeilingNote = "";
  carBaseboardWallCeilingDocs = [];

  carStopSwitch = false;
  carStopSwitchNote = "";
  carStopSwitchDocs = [];

  carControlPanels = false;
  carControlPanelsNote = "";
  carControlPanelsDocs = [];

  carLighting = false;
  carLightingNote = "";
  carLightingDocs = [];

  carVentilation = false;
  carVentilationNote = "";
  carVentilationDocs = [];

  // at every stop
  stopInfoSigns = false;
  stopInfoSignsNote = "";
  stopInfoSignsDocs = [];

  stopConciseness = false;
  stopConcisenessNote = "";
  stopConcisenessDocs = [];

  stopSignals = false;
  stopSignalsNote = "";
  stopSignalsDocs = [];

  stopShaftDoorLocks = false;
  stopShaftDoorLocksNote = "";
  stopShaftDoorLocksDocs = [];

  stopGlassDoor = false;
  stopGlassDoorNote = "";
  stopGlassDoorDocs = [];

  stopGlassDoorDamage = false;
  stopGlassDoorDamageNote = "";
  stopGlassDoorDamageDocs = [];

  stopRevolvingDoorSafety = false;
  stopRevolvingDoorSafetyNote = "";
  stopRevolvingDoorSafetyDocs = [];

  stopSignalsOutdoorPanels = false;
  stopSignalsOutdoorPanelsNote = "";
  stopSignalsOutdoorPanelsDocs = [];

  stopDoorAutomaticClosing = false;
  stopDoorAutomaticClosingNote = "";
  stopDoorAutomaticClosingDocs = [];

  stopDoorSill = false;
  stopDoorSillNote = "";
  stopDoorSillDocs = [];


  // in the engine room (er)
  erSafeAccess = false
  erSafeAccessNote = "";
  erSafeAccessDocs = [];

  erClosureMarking = false;
  erClosureMarkingNote = "";
  erClosureMarkingDocs = [];

  erLightingSockets = false;
  erLightingSocketsNote = "";
  erLightingSocketsDocs = [];

  erFloorWall = false;
  erFloorWallNote = "";
  erFloorWallDocs = [];

  erCovers = false;
  erCoversNote = "";
  erCoversDocs = [];

  erPowerUnit = false;
  erPowerUnitNote = "";
  erPowerUnitDocs = [];

  erGear = false;
  erGearNote = "";
  erGearDocs = [];

  erBreak = false;
  erBreakNote = "";
  erBreakDocs = [];

  erRolls = false;
  erRollsNote = "";
  erRollsDocs = [];

  erSpeedLimiter = false;
  erSpeedLimiterNote = "";
  erSpeedLimiterDocs = [];

  erVentilation = false;
  erVentilationNote = "";
  erVentilationDocs = [];

  erCleanliness = false;
  erCleanlinessNote = "";
  erCleanlinessDocs = [];


  // In the shaft/elevator car roof
  shaftEmergencyBrakeSwitch = false;
  shaftEmergencyBrakeSwitchNote = "";
  shaftEmergencyBrakeSwitchDocs = [];

  shaftInspectionControl = false;
  shaftInspectionControlNote = "";
  shaftInspectionControlDocs = [];

  shaftEmergencyCallDevice = false;
  shaftEmergencyCallDeviceNote = "";
  shaftEmergencyCallDeviceDocs = [];

  shaftSwitch = false;
  shaftSwitchNote = "";
  shaftSwitchDocs = [];

  shaftRailBracketsScrewFittings = false;
  shaftRailBracketsScrewFittingsNote = "";
  shaftRailBracketsScrewFittingsDocs = [];

  shaftSafetyGear = false;
  shaftSafetyGearNote = "";
  shaftSafetyGearDocs = [];

  shaftSlidingBlocksDuct = false;
  shaftSlidingBlocksDuctNote = "";
  shaftSlidingBlocksDuctDocs = [];

  shaftDoorContact = false;
  shaftDoorContactNote = "";
  shaftDoorContactDocs = [];

  shaftDoorMechanics = false;
  shaftDoorMechanicsNote = "";
  shaftDoorMechanicsDocs = [];

  shaftSuspension = false;
  shaftSuspensionNote = "";
  shaftSuspensionDocs = [];

  shaftCabinApron = false;
  shaftCabinApronNote = "";
  shaftCabinApronDocs = [];

  shaftFallProtectionOnRoof = false;
  shaftFallProtectionOnRoofNote = "";
  shaftFallProtectionOnRoofDocs = [];

  shaftLighting = false;
  shaftLightingNote = "";
  shaftLightingDocs = [];

  shaftCabinRoofCleanliness = false;
  shaftCabinRoofCleanlinessNote = "";
  shaftCabinRoofCleanlinessDocs = [];

  shaftCleanliness = false;
  shaftCleanlinessNote = "";
  shaftCleanlinessDocs = [];

  shaftSlidingBlocksDuctCounterweight = false;
  shaftSlidingBlocksDuctCounterweightNote = "";
  shaftSlidingBlocksDuctCounterweightDocs = [];

  shaftBottomRopeAttachmentCounterweight = false;
  shaftBottomRopeAttachmentCounterweightNote = "";
  shaftBottomRopeAttachmentCounterweightDocs = [];


  // In the shaft pit
  shaftPitOpticalBuffer = false;
  shaftPitOpticalBufferNote = "";
  shaftPitOpticalBufferDocs = [];

  shaftPitTensionWeightSpeedLimiter = false;
  shaftPitTensionWeightSpeedLimiterNote = "";
  shaftPitTensionWeightSpeedLimiterDocs = [];

  shaftPitGovernorTensionWeightSwitch = false;
  shaftPitGovernorTensionWeightSwitchNote = "";
  shaftPitGovernorTensionWeightSwitchDocs = [];

  shaftPitEmergencyBrakeSwitch = false;
  shaftPitEmergencyBrakeSwitchNote = "";
  shaftPitEmergencyBrakeSwitchDocs = [];

  shaftPitSuspensionCable = false;
  shaftPitSuspensionCableNote = "";
  shaftPitSuspensionCableDocs = [];

  shaftPitFloorCleanliness = false;
  shaftPitFloorCleanlinessNote = "";
  shaftPitFloorCleanlinessDocs = [];

  shaftPitLadder = false;
  shaftPitLadderNote = "";
  shaftPitLadderDocs = [];

  shaftPitCounterweightCladding = false;
  shaftPitCounterweightCladdingNote = "";
  shaftPitCounterweightCladdingDocs = [];

  constructor() {
  }
}
